import * as React from "react"
import { client } from "@/services/api"
import { ErrorBoundary } from "@/components"
import { ApolloProvider } from "@apollo/react-hooks"
import { BrowserRouter } from "react-router-dom"
import smoothscroll from "smoothscroll-polyfill"
import { UserProvider } from "@/components"
import { routes } from "@/helpers"
import { i18n } from "@/i18n"
import { I18nextProvider } from "react-i18next"
import { useWineryTagManager } from "@/helpers/hooks/useWineryTagManager"
import Main from "@/components/Main/Main"
// eslint-disable-next-line
import "mapbox-gl/dist/mapbox-gl.css"

const App = () => {
  smoothscroll.polyfill()
  useWineryTagManager()

  return (
    <I18nextProvider i18n={i18n}>
      <ErrorBoundary>
        <ApolloProvider client={client}>
          <UserProvider>
            <BrowserRouter basename={routes.base}>
              <Main />
            </BrowserRouter>
          </UserProvider>
        </ApolloProvider>
      </ErrorBoundary>
    </I18nextProvider>
  )
}

export default App
